import Vue from 'vue'
import vuexI18n from 'vuex-i18n'

export default function(time) {
  var d;
  if(typeof time === 'string') {
    d = new Date(time.replace(/ /g,'T'));
    const myTimeZone = 8;
    d.setTime( d.getTime() + myTimeZone * 60 * 60 * 1000 );
  } else {
    d = new Date(time);
  }
  var delta = Math.round((+new Date - d) / 1000);
  var minute = 60,
    hour = minute * 60,
    day = hour * 24,
    week = day * 7,
    month = day * 30,
    year = day * 356;
  var suffix = "";
  var value = "";
  if (delta < 30) {
    suffix = 'time.justNow';
  } else if (delta < minute) {
    suffix = 'time.secondsAgo';
    value = delta;
  } else if (delta < 2 * minute) {
    suffix = 'time.minuteAgo';
  } else if (delta < hour) {
    value = Math.floor(delta / minute);
    suffix = 'time.minutesAgo';
  } else if (Math.floor(delta / hour) == 1) {
    suffix = 'time.hourAgo';
  } else if (delta < day) {
    value = Math.floor(delta / hour);
    suffix = 'time.hoursAgo';
  } else if (delta < day * 2) {
    suffix = 'time.yesterday';
  } else if (delta < day * 7) {
    value = Math.floor(delta / day);
    suffix = 'time.daysAgo';
  } else if (delta < month) {
    value = Math.floor(delta / week);
    suffix = 'time.weeksAgo';
  } else if (delta < year) {
    value = Math.floor(delta / month);
    suffix = 'time.monthsAgo';
  } else {
    value = Math.floor(delta / year);
    suffix = 'time.yearsAgo';
  }
  return {
    suffix: suffix,
    value: value
  };
};